import DqUsermenu from './src/usermenu'

/* istanbul ignore next */
DqUsermenu.install = function (Vue) {
  Vue.component(DqUsermenu.name, DqUsermenu)
}

export default DqUsermenu



// WEBPACK FOOTER //
// ./src/dq-ui/packages/usermenu/usermenu.js